import { SPECIAL_OPTION } from '../constants';
import { ViewerAttributeInterface, ViewerGroupInterface, ViewerOptionInterface } from '../models';
import { instanceOfViewerGroupAttribute, instanceOfViewerGroupCustomizations, instanceOfViewerGroupStep } from '../services';

const isOptionNotSetSelected = (attributes: ViewerAttributeInterface[]) => {
  return attributes.some((attribute) => attribute.options.some((option) => option.selected && option.id === SPECIAL_OPTION.NOT_SET));
};

export const isAddToCartDisabled = (groups: ViewerGroupInterface[]) => {
  return groups.some((group) => {
    if (instanceOfViewerGroupStep(group)) {
      return group.steps.some((step) => {
        return isOptionNotSetSelected(step.attributes);
      });
    } else if (instanceOfViewerGroupAttribute(group)) {
      return isOptionNotSetSelected(group.attributes);
    } else if (instanceOfViewerGroupCustomizations(group) && group.customizations?.length) {
      const engraving = group.customizations[0];
      const { maxNrChars, minNrChars } = engraving.constraint || { maxNrChars: null, minNrChars: null };
      const text = engraving.text || '';
      return (minNrChars && minNrChars > text.length) || (maxNrChars && maxNrChars < text.length);
    } else {
      return false;
    }
  });
};

export const customStylesTheme = (custom_styles: Record<string, any> | undefined) => {
  if (!custom_styles) return;
  const { REACT_APP_CUSTOMIZATION_BASE_URL: CUSTOMIZATION_URL } = process.env;
  const headTag = document.getElementsByTagName('head')[0];
  const styleTag = document.createElement('style');
  let scss_variables = ``;
  let fonts_load = [];
  for (var prop in custom_styles) {
    if (prop.match(/font/i) && typeof custom_styles[prop] === 'object') {
      // Push Fonts to Load into Container
      fonts_load.push({
        name: custom_styles[prop].name,
        src: `${CUSTOMIZATION_URL}${custom_styles[prop].src}`,
      });
      // Set font name variable
      scss_variables += `--${prop}-name: ${custom_styles[prop].name};`;
    } else {
      if (custom_styles[prop] && custom_styles[prop] !== '') {
        // Set standard variable
        scss_variables += `--${prop}: ${custom_styles[prop]};`;
      }
    }
  }
  styleTag.innerHTML += `:root { ${scss_variables} }`;
  headTag.appendChild(styleTag);

  // Load Fonts form the Container
  fonts_load.forEach((font, i) => {
    const loadFontFace = new FontFace(font.name, `url(${font.src})`);
    document.fonts.add(loadFontFace);
  });
};

export const hideAttributeIfHasOneOption = (attribute: ViewerAttributeInterface, hideAttributeParam: boolean | undefined) => {
  if (!hideAttributeParam) return false;
  if (hideAttributeParam && attribute.options.length <= 1) return true;
  else return false;
};

export const textHelpHtml = (text: string) => {
  return { __html: text };
};
